const FEATURE_FLAGS = {
    ANOC_CONFIGURATOR: 'anoc-configurator',
    AUTO_CREATE_TASK: 'auto-create-task',
    CASE_REASSIGN_CALL_ROUTING_QUEUES: 'case-reassign-call-routing-queues',
    CRM_REMINDERS: 'crm-reminders',
    ENABLE_NEW_WORKFLOW_BUTTONS: 'enable-new-workflow-buttons',
    ENABLE_WORKFLOW_PENDING_SAVE: 'enable-workflow-pending-save',
    ENABLE_TEXT_REPLACE: 'enable-text-replace',
    ENABLE_MY_QUEUE_MY_WORK: 'enable-my-queue-my-work-tab',
    INBOUND: 'inbound',
    MAIL_MATERIAL_FLAG: 'mail-material-request-preview',
    MEMBER_MIDDLE_NAME_FEATURE_FLAG: 'crm-member-middle-name',
    MEMBER_REIMBURSEMENT_SERVICE_ACTION: 'member-reimbursement-service-action',
    NETWORK_TELEMETRY: 'network-telemetry',
    ONE_PASS_BUBBLE: 'one-pass-bubble',
    PCP_CHANGE_ADD_PROVIDER: 'enable-pcp-change-add-provider',
    PCP_CHANGE_V2: 'pcp-chang-v2',
    PHYSICAL_MEMBER_CARD: 'physical-member-card',
    REQUEST_PLAN_MATERIAL_ALL_PROFILE_STATUSES: 'request-plan-material-enable-all-profile-statuses',
    REQUEST_PLAN_MATERIAL_CONFIG_EDITOR: 'request-plan-material-config-editor',
    SERVICE_ACTION_EZM_MAINTENANCE: 'service-action-ezm-maintenance',
    SERVICE_ACTIONS_SLA: 'service-actions-sla',
    SIGN_IN_EVENTS: 'sign-in-events',
    SIMULATE_INBOUND_CALL: 'simulate-inbound-call',
    STICKY_NOTE_BULK_UPLOAD: 'enable-sticky-note-bulk-upload',
    SSBCI_MEALS: 'ssbci-meals',
    SSBCI_STATUS_FETCH: 'ssbci-status-fetch',
    TALKDESK_CLICK_TO_CALL: 'talkdesk-click-to-call-input',
    TALKDESK_INTEGRATION: 'talkdesk-integration',
    TALKDESK_INBOUND_CALLS: 'talkdesk-inbound-calls',
    TALKDESK_LOGIN_REMINDERS: 'talkdesk-login-reminders',
    TALKDESK_OUTBOUND_CALLS: 'talkdesk-outbound-calls',
    WORKLIST_TAB_ENABLED: 'worklist-tab-enabled',
    WORKLIST_TAB_LEADERSHIP: 'worklist-tab-leadership',
    OFFICE_GENERATION_TOOL: 'office-generator-tool',
} as const;

export type FeatureFlagKeys = keyof typeof FEATURE_FLAGS;
export type FeatureFlagNames = (typeof FEATURE_FLAGS)[FeatureFlagKeys];

export default FEATURE_FLAGS;
